import { buttonShadow } from './buttonShadow';
import { roundRect } from './roundRect';

export function roundRect2(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  r: number,
  fillColor?: string,
  lineColor?: string,
  thick = 1,
  includeShadow?: boolean
): void {
  ctx.save();

  // Shadow settings (thin gray shadow on lower-right)
  if (includeShadow) {
    buttonShadow(ctx, x, y, w, h, r);
  }

  ctx.lineWidth = thick;
  roundRect(ctx, x, y, w, h, r);

  ctx.strokeStyle = lineColor ?? 'lightgray';
  ctx.stroke();

  if (fillColor) {
    ctx.fillStyle = fillColor;
    ctx.fill();
  }

  ctx.restore();
}
